import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/home/home';
import Products from '../pages/products/index';
import Pricing from '../pages/pricing/index';
import Contact from '../pages/contact/index';
import OurVision from '../pages/our-vision/index';
import LegalNotice from '../pages/legal/legal-notice/index';
import PrivacyPolicy from '../pages/legal/privacy-policy/index';
import NewsletterSite from '../pages/newsletter/index'

function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/our-vision" element={<OurVision />} />

            <Route path="/impressum" element={<LegalNotice />} />
            <Route path="/datenschutz" element={<PrivacyPolicy />} />
            {/* Dynamische Newsletter-Route */}
            <Route path="/newsletter/:id" element={<NewsletterSite />} />
        </Routes>
    );
}

export default AppRoutes;
